import { DocumentNode, gql } from '@apollo/client'

export const REQUEST_CHANGE_PASSWORD: DocumentNode = gql`
    mutation RequestChangePassword($email: String!) {
        requestChangePassword(email: $email)
    }
`

export const CHANGE_PASSWORD: DocumentNode = gql`
    mutation ChangePassword($token: String!, $password: String!) {
        changePassword(token: $token, password: $password)
    }
`
